import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=34eda575&scoped=true&lang=pug&"
var script = {}
import style0 from "./Gallery.vue?vue&type=style&index=0&id=34eda575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eda575",
  null
  
)

export default component.exports